/** Runtime configuration served by the API (one image serves prod and demo). */
export interface RuntimeConfig {
  environment: string;
  demo: boolean;
  auth_provider: "firebase" | "fake";
  firebase: { apiKey: string; authDomain: string; projectId: string };
  auth_emulator_url: string | null;
  version: string;
}

let cached: Promise<RuntimeConfig> | null = null;

export function loadConfig(): Promise<RuntimeConfig> {
  cached ??= fetch("/api/v1/config").then(async (response) => {
    if (!response.ok) throw new Error(`Configuration unavailable (${response.status})`);
    return (await response.json()) as RuntimeConfig;
  });
  return cached;
}
